import { APP_VERSION } from '../js/utils/version.js';

export const EN = {
    // ===== MENU =====
    'menu.title': 'ARCHIVE OF FORGOTTEN MEMORIES',
    'menu.subtitle': 'The Covenant of Mneme',
    'menu.newGame': 'New Game',
    'menu.continue': 'Continue',
    'menu.options': 'Settings',
    'menu.quit': 'Exit Game',
    'menu.version': `Version ${APP_VERSION} – AAA Overhaul`,

    // ===== OPTIONS =====
    'options.title': 'Game Settings',
    'options.language': 'Language / Sprache',
    'options.lang_de': 'Deutsch 🇩🇪',
    'options.lang_en': 'English 🇬🇧',
    'options.audio': 'Audio & Sound',
    'options.particles': 'Particle Effects',
    'options.floatingText': 'Combat Numbers',
    'options.cloudSync': 'Cloud Sync',
    'options.autosave': 'Auto Save Interval',
    'options.deleteSave': 'Reset Savegame',
    'options.close': 'Close',
    'options.enabled': 'Enabled',
    'options.disabled': 'Disabled',

    // ===== HUB / NAVIGATION =====
    'hub.hero': 'Hero',
    'hub.quests': 'Quests',
    'hub.forge': 'Forge',
    'hub.crafting': 'Crafting',
    'hub.skilltree': 'Skills',
    'hub.codex': 'Codex',
    'hub.clan': 'Clan',
    'hub.guild': 'Guild',
    'hub.friends': 'Friends',
    'hub.leaderboard': 'Leaderboard',
    'hub.story': 'Chronicle',
    'hub.relicHunt': 'Relic Hunt',
    'hub.chat': 'Chat',

    // ===== HERO =====
    'hero.title': 'Keeper of the Mneme',
    'hero.level': 'Level',
    'hero.xp': 'Experience',
    'hero.hp': 'Health Points',
    'hero.atk': 'Attack',
    'hero.def': 'Defense',
    'hero.crit': 'Critical Hit',
    'hero.prestige': 'Eternalize',
    'hero.inventory': 'Inventory',
    'hero.equipment': 'Equipment',
    'hero.stats': 'Attributes',

    // ===== AUTH & ACCOUNT =====
    'auth.title': 'USER ACCOUNT',
    'auth.login': 'Sign In',
    'auth.register': 'Register',
    'auth.logout': 'Sign Out',
    'auth.guest': 'Guest Mode',
    'auth.username': 'Username',
    'auth.email': 'Email Address',
    'auth.password': 'Password',
    'auth.guestBadge': 'Guest Keeper',
    'auth.loggedInAs': 'Signed in as',
    'auth.upgradeGuest': 'Register Account Now',
    'auth.accountDetails': 'Account Details',
    'auth.created': 'Member since',
    'auth.syncStatus': 'Cloud Sync',
    'auth.error.missing_fields': 'Please fill in all required fields.',
    'auth.error.user_not_found': 'User or email not found.',
    'auth.error.wrong_password': 'The entered password is incorrect.',
    'auth.error.username_short': 'Username must be at least 3 characters.',
    'auth.error.email_invalid': 'Please enter a valid email address.',
    'auth.error.password_short': 'Password must be at least 6 characters.',
    'auth.error.username_taken': 'This username is already taken.',
    'auth.error.email_taken': 'This email address is already in use.',
    'auth.error.server_timeout': 'Server connection timed out.',
    'auth.error.not_guest': 'Account is not a guest account.',
    'auth.error.server_error': 'Server error occurred. Please try again later.',
    'auth.success.registered': 'Account created successfully!',
    'auth.success.registeredPopup': 'Your account was created successfully! You are now being redirected to the login form.',
    'auth.success.registeredTitle': 'REGISTRATION SUCCESSFUL',
    'auth.success.login': 'Welcome back, Keeper!',
    'auth.success.guestConverted': 'Guest account successfully registered!',

    // ===== UI & ACTION KEYS =====
    'ui.bulk_salvage': 'Bulk Salvage',
    'ui.salvage_all': 'Salvage All Common',
    'ui.confirm_salvage': 'Are you sure you want to salvage these items?',

    // ===== COMMON =====
    'common.confirm': 'Confirm',
    'common.cancel': 'Cancel',
    'common.close': 'Close',
    'common.back': 'Back',
    'common.save': 'Save',
    'common.success': 'Success!',
    'common.error': 'Error!',
    'common.loading': 'Loading data...'
};

